import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
:root {
  --msk-color: #000;
  --msk-bg: #FFF;
  --bnb-container-width: 1360px;
  
  min-width: 100%;
  min-height: 100%;
}

// Layout debugging
// * {
//   outline: 1px solid red;
// }

.msk__body--loading {
  overflow: hidden;
}

.msk__body--nocursor {
  cursor: none;
}

.msk__body--nooverflow {
  overflow: hidden;
}

.msk__body--nooverflowx {
  overflow-x: hidden;
}

.msk__stats-gl {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999;
}

#beacon-container {
  position: absolute;
  z-index: 9999;

  @media (min-width: 640px) {
    position: static;
  }
}
`
